import React from 'react'
import {
    TiaModal,
    Flex,
    Text,
    Heading,
    Button,
    Box,
    Icon,
    Link,
    Paragraph
} from '..'
import { useModal } from 'react-modal-hook'
import { useState } from 'react'

export interface ConfirmDialogProps {
    title?: string
    desc?: string
    confirmText?: string
    cancelText?: string
    onConfirm: (closeModal: () => void) => any
}

const ConfirmationDialog = ({
    title = 'Are you sure?',
    desc,
    confirmText = 'Yes',
    cancelText = 'No',
    onConfirm,
    onClose
}: ConfirmDialogProps & { onClose?: () => void }) => {
    const [submitting, setSubmitting] = useState(false)
    const closeRequest = () => {
        if (!submitting && onClose) {
            onClose()
        }
    }

    return (
        <TiaModal
            shouldCloseOnOverlayClick={true}
            onRequestClose={closeRequest}
        >
            <Flex
                sx={{
                    justifyContent: 'space-between',
                    alignItems: 'left',
                    mb: 4
                }}
            >
                <Heading h2 sx={{ m: 0, p: 0 }}>
                    {title}
                </Heading>
                <Box
                    onClick={closeRequest}
                    sx={{ cursor: submitting ? 'default' : 'pointer' }}
                >
                    <Icon.Close color={submitting ? 'grey10' : 'text'} />
                </Box>
            </Flex>
            {desc && <Paragraph sx={{ mb: 5 }}>{desc}</Paragraph>}

            <Box sx={{ textAlign: 'center' }}>
                <Button
                    fullWidth
                    sx={{ mb: 4 }}
                    loading={submitting}
                    onClick={() => {
                        setSubmitting(true)
                        onConfirm(() => {
                            setSubmitting(false)
                            onClose && onClose()
                        })
                    }}
                >
                    {confirmText}
                </Button>
                <Link
                    onClick={onClose}
                    sx={{
                        fontSize: 2,
                        color: submitting ? 'grey10' : 'defaultText',
                        cursor: submitting ? 'default' : 'pointer'
                    }}
                >
                    {cancelText}
                </Link>
            </Box>
        </TiaModal>
    )
}

export const useConfirmation = () => {
    const [modalProps, setModalProps] = useState<ConfirmDialogProps>({
        onConfirm: close => {
            close()
        }
    })
    const [showModal, hideModal] = useModal(
        () => <ConfirmationDialog {...modalProps} onClose={hideModal} />,
        [modalProps]
    )

    return (props: ConfirmDialogProps) => {
        setModalProps(props)
        showModal()
    }
}
